export default "__VITE_ASSET__463fcb40__"